export default __webpack_public_path__ + "static/media/reject_icon.36d4407b.svg";